/******************************************************************
 * Archivo : client/src/queries/fetchUser.js
 * Proyecto: CB30
 ******************************************************************/

import gql from "graphql-tag";

export default gql`
  query UserQuery {
    user {
      id
      validated

      roles {
        id
        code
        label

      permissions {
        id
        code
        module
        functionality
      }
    }

      email
      nombre
      apellido
      tipoPerfil

      person {
        tipo_de_documento
        documento_de_identidad
        lugar_de_expedicion
        fecha_de_nacimiento
        lugar_de_nacimiento
        pais_de_nacimiento
        genero
        raza
        grupo_etnico
        estado_civil
        nivel_educativo
        ocupacion
        direccion
        estrato
        localidad
        departamento
        ciudad
        pais_de_residencia
        telefono
        celular
      }

      surveys {
        surveyId
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/queries/fetchUser.js